module.exports = __webpack_public_path__ + "static/media/strongher9_preview.bb6be507.jpg";